/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { SectionHeader } from '../Shared/SectionHeader'
import { Section } from '../Shared/Section'
import { OpeningCard } from './Cards/OpeningCard'
import { NextClosureCard } from './Cards/NextClosureCard'
import { BusyModeDurationCard } from './Cards/BusyModeDurationCard'
import { isProviderAPos } from '../../../services/Provider/Provider.service'
import useUser from '../../Shared/UserProvider/useUser'
import { ScanRateCard } from './Cards/ScanRateCard'
import { useQuery } from '@tanstack/react-query'
import { getOperationalPerformanceMetrics } from '../../../services/Metrics/Metrics.service'
import { formatISO, roundToNearestMinutes, startOfDay, subDays } from 'date-fns'
import { FoundRateCard } from './Cards/FoundRateCard'
import { useTranslation } from 'react-i18next'

const OperationalPerformanceSection = () => {
    const [t] = useTranslation()

    const {user} = useUser()

    const from = formatISO(startOfDay(subDays(new Date(), 7)))
    const to = roundToNearestMinutes(new Date(), {nearestTo: 10, roundingMethod: 'floor'}).toISOString()

    const { data: operationalPerformance, isLoading } = useQuery({
        queryKey: ['operational-performance', from, to],
        queryFn: () => getOperationalPerformanceMetrics(from, to),
    })

    return (
      <>
          <SectionHeader title={t('dashboard.operational_performance')}/>

          <Section>
              <OpeningCard/>

              {isProviderAPos(user.provider) && (
                <div
                  css={css`
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                      height: 210px;
                      gap: 1rem;
                  `}
                >
                    <NextClosureCard/>
                    <BusyModeDurationCard/>
                </div>
              )}

              <ScanRateCard
                scanRate={operationalPerformance?.scanRate}
                isLoading={isLoading}
              />

              <FoundRateCard
                foundRate={operationalPerformance?.foundRate}
                isLoading={isLoading}
              />
          </Section>
      </>
    )
}

export { OperationalPerformanceSection }
